import { AfterViewInit, Component, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { MatSidenav } from "@angular/material/sidenav";
import { ActivatedRoute } from "@angular/router";
import { Subscription, Observable, firstValueFrom } from "rxjs";
import { FormStatusEnum, FormType, ResourceType } from "src/app/common/enumerations/enumerations";
import { CancelDialogComponent } from "src/app/controls/cancel-dialog/cancel-dialog.component";
import { ActionItemsStoreAndListenersService } from "src/app/controls/catl/action-item/store/actionItems.store";
import { Procedure } from "src/app/components/procedure/models/procedure.model";
import { RadLocation } from "src/app/components/catalogs/rad-monitor/rad-monitor/rad-location";
import { RadMonitor } from "src/app/components/catalogs/rad-monitor/rad-monitor/rad-monitor";
import { Resource } from "src/app/components/catalogs/beamline-catalog/resource/resources";
import { PrivilegeEnum } from "src/app/common/enumerations/privilege-enum";
import { RSSFunctionalTestService } from "src/app/services/rss-functional-test/rss-functional-test.service";
import { User } from "src/app/components/catalogs/user-catalog/services/user";
import { WFSectionLocalResource, WFStepLocalResource, WfSignature } from '../../workflow/workflow';
import { FormStatusesStoreAndListenersService } from "src/app/store/form-status/form-status.store";
import { RSSFunctionalTest } from "../../rsswa/rss-functional-test";
import { ScheduleStatusEnum } from "../../schedules/models/enums";
import { Schedule } from "../../schedules/models/schedule";
import { SchedulesStoreAndListenersService } from "../../schedules/store/schedules/schedule.store";
import { ChecklistBuilderService } from "../checklist-builder/checklist-builder.service";
import { Checklist, TemplateType, ChecklistTemplate, TemplateRolePermission, ChecklistPriv, ChecklistTemplateStatusEnum, SaveChecklistStatusResource, Annotation, AnnotationStatus } from "../checklists";
import { ChecklistsService } from "../checklists.service";
import { ChecklistTemplatesRefreshByDocument } from "../store/checklist-templates/checklist-templates.action";
import { ChecklistsUpdate } from "../store/checklists/checklists.action";
import { TemplateTypesRefreshByDocument } from "../store/template-types/template-types.action";
import { ChecklistExecSideComponent } from "./checklist-exec-side/checklist-exec-side.component";
import { BaseComponent } from "src/app/common/base/base.component";
import { DocumentType } from "src/app/services/documents/documents";
import { RadMonitorService } from "../../catalogs/rad-monitor/services/rad-monitor.service";
import { PlaceholdersService } from "src/app/services/placeholders/placeholders.service";
import { Review } from "../../reviews/reviews.models";

@Component({
  selector: "checklist-exec",
  templateUrl: "./checklist-exec.component.html",
  styleUrls: ["./checklist-exec.component.scss"],
})
export class ChecklistExecComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly genericKeyEnableTemplateDocumentTypeID = 301;

  public radMonitorSubscription!: Subscription;
  public radLocSubscription!: Subscription;

  public radMonitors$!: Observable<RadMonitor[]>;
  public radLocations$!: Observable<RadLocation[]>;

  public radMonitors!: RadMonitor[];
  public radLocations!: RadLocation[];

  @ViewChild("sidenav") sidenav!: MatSidenav;

  @ViewChild(ChecklistExecSideComponent) public side!: ChecklistExecSideComponent;
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) typeTrigger!: MatAutocompleteTrigger;

  @Output() toggleSidePanel = new EventEmitter<any>();

  documentTypeId!: number;
  documentType?: DocumentType;
  documentTypes!: DocumentType[];
  documentTypes$!: Observable<DocumentType[]>;
  checklistDocumentType?: DocumentType;

  resourceBased!: boolean;
  participants!: User[];

  currentChecklist?: Checklist | null;

  formStatus = FormStatusEnum;

  tmpType!: string;
  currentTemplateType?: TemplateType | null;
  templateTypes$!: Observable<TemplateType[]>;
  templateTypes!: TemplateType[];
  filteredTemplateTypes!: TemplateType[];
  loadingTypes!: boolean;
  typeCtrl = new FormControl();

  currentResource?: Resource | null;
  resources!: (Resource | undefined)[];

  currentSchedule?: Schedule | null;
  schedules!: Schedule[];
  schedules$!: Observable<Schedule[]>;
  filteredSchedules!: Schedule[];

  currentChecklistTemplate?: ChecklistTemplate | null;
  templateCtrl = new FormControl();

  creating!: boolean;
  creatingNew = false;
  showLoader = true;

  sections!: WFSectionLocalResource[];
  allSections!: WFSectionLocalResource[];
  templateRolePermissions!: TemplateRolePermission[];
  documentRolePermissions!: TemplateRolePermission[];

  checklistPrivilege = ChecklistPriv;

  precheck!: boolean;

  filter?: string | null;
  subscription!: Subscription;
  templateTypesSubs!: Subscription;
  schedulesSubs!: Subscription;
  sectionsSubs!: Subscription;

  sections$!: Observable<WFSectionLocalResource[]>;

  checklists: Checklist[] = [];
  checklists$!: Observable<Checklist[]>;
  checklistsSubs!: Subscription;

  checklistTemplates!: ChecklistTemplate[];
  checklistTemplatesFiltered?: ChecklistTemplate[];
  checklistTemplates$!: Observable<ChecklistTemplate[]>;
  checklistTemplatesSubs!: Subscription;

  annotations!: Annotation[];
  annotations$!: Observable<Annotation[]>;
  annotationsSubs!: Subscription;
  totalAnnotations!: number;
  activeAnnotations!: number;

  reviews?: Review[];
  reviewsFiltered?: Review[];
  reviews$!: Observable<Review[]>;
  reviewsSubs!: Subscription;

  scheduleBased!: boolean;

  rssFunctionalTest!: RSSFunctionalTest | null;

  currentProcedure?: Procedure | null;
  procedures!: (Procedure | undefined)[];
  filteredProcedures!: Procedure[];
  procedureCtrl = new FormControl();

  sub!: Subscription;
  procedure!: Procedure;

  collapsedAll = true;

  isCollapsible!: boolean;
  isProcedureRelated!: boolean;

  constructor(
    protected override injector: Injector,
    private route: ActivatedRoute,
    private builderService: ChecklistBuilderService,
    private service: ChecklistsService,
    private placeholdersService: PlaceholdersService,
    private rmService: RadMonitorService,
    private rssFunctionalTestService: RSSFunctionalTestService,
    actionItemsStore: ActionItemsStoreAndListenersService,
    scheduleStore: SchedulesStoreAndListenersService,
    formStatusStore: FormStatusesStoreAndListenersService,
  ) {
    super(injector);

    scheduleStore.initStore();
    scheduleStore.initListeners();

    formStatusStore.initListeners();
    formStatusStore.initStore();
    actionItemsStore.initStore(0);
    actionItemsStore.initListeners();
  }

  ngAfterViewInit(): void {
    this.setHeights();
  }


  override ngOnDestroy(): void {
    this.clearDocumentTypeSubscriptions();
    this.sub?.unsubscribe();
    super.ngOnDestroy();
  }

  /**
   * Clears document-specific subscriptions while preserving route and base user subscriptions.
   */
  private clearDocumentTypeSubscriptions(): void {
    this.subscription?.unsubscribe();
    this.templateTypesSubs?.unsubscribe();
    this.schedulesSubs?.unsubscribe();
    this.sectionsSubs?.unsubscribe();
    this.checklistsSubs?.unsubscribe();
    this.radMonitorSubscription?.unsubscribe();
    this.radLocSubscription?.unsubscribe();
    this.checklistTemplatesSubs?.unsubscribe();
    this.reviewsSubs?.unsubscribe();
  }

  /**
   * Rebuilds role-filtered Template Types after the base user subscription receives roles.
   */
  override currentUserUpdated(): void {
    if (this.documentTypeId && this.documentRolePermissions) {
      this.templateTypesSubs?.unsubscribe();
      this.loadTemplateTypes();
    }
  }

  ngOnInit() {
    this.placeholdersService.clearkeyValues();
    this.placeholdersService.getAll().toPromise();
    this.sub = this.route.params.subscribe((params) => {
      if (this.documentTypeId != +params["type"]) {
        // Changing document type should not destroy base subscriptions needed for user roles.
        this.clearDocumentTypeSubscriptions();
        this.loadDocumentTypes();
        this.clear();
        this.clearSelection();
        this.documentTypeId = +params["type"].toString().split('?')[0];
        this.getInfo();

        this.loadTemplateTypes();
        this.loadSchedules(); //loads procedures
        this.checklistTemplatesSubs?.unsubscribe(); // Unsubscribe from existing subscription
        this.loadChecklistTemplates();
        this.loadChecklists();
        this.loadReviews();
      }
      this.store.dispatch(
        new TemplateTypesRefreshByDocument(this.documentTypeId)
      );
      this.store.dispatch(
        new ChecklistTemplatesRefreshByDocument(this.documentTypeId)
      );
    });
  }

  loadChecklists() {
    this.checklists$ = this.store.select((state) => state.Checklists.data);
    this.checklistsSubs = this.checklists$.subscribe(async (data) => {
      if (data.length) {
        this.checklists = data.filter(x => x.checklistTemplate?.documentTypeID == this.documentTypeId);
        const checklistOpen = await this.checkOpenDocument<Checklist>(this.documentTypeId, this.checklists);
        if (checklistOpen) this.currentChecklist = this.getHydratedChecklist(checklistOpen.document);
        if (this.currentChecklist) {
          this.currentChecklist = this.getHydratedChecklist(this.currentChecklist);
          if (this.currentChecklist)
            this.currentChecklist.createdByName = this.getUser(this.currentChecklist.createdBy)?.name;
          if (this.currentChecklist.wfTable)
            this.rowSelected(this.currentChecklist);
          this.loadAnnotations();
        }
      }
    });
  }

  loadDocumentTypes() {
    this.documentTypes$ = this.store.select((state) => state.DocumentType.data);
    this.subscription = this.documentTypes$.subscribe(async (data) => {
      if (data.length) {
        this.documentTypes = data;
        this.documentType = this.documentTypes.find(x => x.id == this.documentTypeId);
        this.checklistDocumentType = this.documentTypes.find(x => x.id == this.documentType?.type);
      }
    });
  }

  loadReviews() {
    this.reviews$ = this.store.select(state => state.Reviews.data);
    this.reviewsSubs = this.reviews$.subscribe(data => {
      if (data?.length) {
        this.reviews = data;
      }
    });
  }

  // Assume: setKeyValuePairs(...) returns Promise<void>
  // Types: Checklist, WFSectionLocalResource, RadMonitor

  /**
   * Loads the selected checklist and prepares its resource placeholders.
   * On screens narrower than 992px, picking a different checklist also collapses the side panel so the checklist gets the full width.
   * @param e - Checklist selected by the user, or a store refresh of the current one.
   */
  async rowSelected(e: Checklist | null = null): Promise<void> {
    // 1) Role flag
    this.service.isReviewer =
      this.hasPrivilege(PrivilegeEnum.RadSurveyReviewer) && this.documentTypeId === 12;

    // Bug 6961: the expanded list leaves too little room for the checklist on tablets and phones; store refreshes re-select the same id and don't collapse
    if (e && e.id != this.currentChecklist?.id && window.innerWidth < 992) this.isExpanded = false;

    // 2) Guard: nothing to do if no wfTable
    if (!e?.wfTable) return;

    try {
      const checklistChanged = !!this.currentChecklist && e.id !== this.currentChecklist.id;
      // Clear placeholders only when changing checklists; a partial refresh may temporarily omit the outgoing task payload.
      if (checklistChanged) {
        this.placeholdersService.clearkeyValues();
        this.currentChecklist = null;
      }

      if (e.resourceID) {
        // b) Ensure placeholders exist (based on the checklist resource)
        if (this.placeholdersService.keyValuePairs.length === 0) {
          await this.placeholdersService.setKeyValuePairs(e.resource, false);
        }

        // c) If we still have no placeholders, stop (mirrors original intent)
        if (this.placeholdersService.keyValuePairs.length === 0) return;

        // d) Load selected checklist
        this.getChecklist(e);
      } else {
        // No resourceID path: derive monitor from wf sections
        const sections = (e.wfTable.wfTableLocal?.wfSectionLocals ??
          []) as WFSectionLocalResource[];

        const values = this.rmService.findRadMonitor(sections, 'OUT');
        const monitor = values?.find((r: any) => r.key === 'monitor')?.val as RadMonitor | undefined;
        const savedLocation = values?.find((r: any) => r.key === 'location')?.val as RadLocation | undefined;
        const locationId = values?.find((r: any) => r.key === 'locationId')?.val as number | undefined;

        if (monitor) {
          // Restore the separately saved location so RMCF location and tripset placeholders evaluate after a refresh.
          const catalogLocations = this.store.selectSnapshot(state => state.RadLocation.data) as RadLocation[];
          monitor.radLocation = savedLocation ?? monitor.radLocation ?? catalogLocations?.find(x => x.id === locationId);
          this.placeholdersService.getKeyValuesRadMonitor(monitor, 'rmco');
        }

        this.getChecklist(e);
      }
    } catch (err) {
      console.error('rowSelected error', err);
      // TODO: optional user feedback (snackBar/toast) if you have one
    } finally {
    }
  }


  /**
   * Loads the selected checklist details without replacing hydrated redirect data with a lighter table row.
   * @param checklist Checklist emitted by the side table or loaded from a redirect.
   */
  getChecklist(checklist: Checklist) {
    // Keep the hydrated checklist from redirect/row loading so the body renders on first navigation.
    this.currentChecklist = this.getHydratedChecklist(checklist);
    if (this.currentChecklist) {
      this.currentChecklist.createdByName = this.getUser(this.currentChecklist.createdBy)?.name;
      this.loadInfo();
    }
  }

  /**
   * Chooses the selected checklist instance that still has workflow content available.
   * @param checklist Candidate checklist from redirect, row selection, or store refresh.
   */
  private getHydratedChecklist(checklist: Checklist): Checklist {
    const cachedChecklist = this.checklists?.find(x => x.id == checklist.id);
    if (checklist.wfTable) return checklist;
    if (this.currentChecklist?.id == checklist.id && this.currentChecklist.wfTable) return this.currentChecklist;
    return cachedChecklist?.wfTable ? cachedChecklist : checklist;
  }

  loadProcedures() {
    const hutchFunctionalProcedures = this.schedules.filter(x => x.type.documentTypeId == this.documentType?.type && x.scheduleSubtypeId == 2 && x.subdetail?.procedure).map((x) => x.subdetail?.procedure);

    this.procedures = this.schedules.filter(x => x.type.documentTypeId == this.documentType?.type && x.procedure).map(x => x.procedure);
    this.procedures = this.procedures.concat(hutchFunctionalProcedures);

    this.procedures.map(p => {
      const procedure = this.checklistTemplates?.filter((t) => t.status == 1).find((x) => x.procedureMasterID == p?.procedureMasterID)?.procedure;
      if (procedure) { p = procedure; }
    });
    this.filterProcedures();
    this.isProcedureRelated = this.proceduresVisible();
    this.procedureCtrl.enable();
  }

  filterProcedures() {
    if (this.procedures?.length) {
      const procedures: Procedure[] = [];
      this.procedures?.map(p => {
        const procedure = this.checklistTemplates?.filter((t) => t.status == 1).find((x) => x.procedureMasterID == p?.procedureMasterID)?.procedure;
        if (procedure) procedures.push(procedure);
      });
      procedures.map(p => {
        const index = this.procedures.findIndex(x => x?.procedureMasterID == p.procedureMasterID);
        this.procedures.splice(index, 1);
        this.procedures.push(p);
      });
      this.filteredProcedures = this.procedures.sort((a, b) => this.utils.SortProcedures(a?.procedureNumber, b?.procedureNumber)) as Procedure[];
    }
  }

  loadChecklistTemplates() {
    this.checklistTemplates$ = this.store.select((state) => state.ChecklistTemplates.data);
    this.checklistTemplatesSubs = this.checklistTemplates$.subscribe((data) => {
      if (data.length) {
        this.checklistTemplates = data.filter((t) => t.status == 1);
        this.checklistTemplatesFiltered = this.checklistTemplates.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.resourceString, b.resourceString));
        this.filterProcedures();
      }
    });
  }

  // //#region TemplateTypestemplateCtrl
  loadTemplateTypes() {
    this.templateTypes$ = this.store.select((state) => state.TemplateTypes.data);
    this.templateTypesSubs = this.templateTypes$.subscribe(data => {
      if (data.length && this.documentRolePermissions) {
        this.templateTypes = data?.filter(x => x.status == 1 && x.documentTypeID == this.documentType?.id && this.documentRolePermissions?.filter(p => p.checklistPrivilege == this.checklistPrivilege.CreateChecklist &&
          this.hasRoles([p.roleID]))).sort((a, b) => this.utils.sort(a.order, b.order));
        this.filteredTemplateTypes = this.templateTypes;
        if (this.templateTypes?.length) {
          this.checklistTemplates = this.checklistTemplates.filter((x) => x.status == 1);
          this.checklistTemplatesFiltered = this.checklistTemplates.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.resourceString, b.resourceString));
          if (this.currentChecklist) {
            this.currentChecklistTemplate = this.currentChecklist.checklistTemplate;
            this.currentTemplateType = this.currentChecklist.checklistTemplate?.templateType;
            this.filterSchedules();
            this.resourceBased = (this.currentTemplateType?.resourceTypeID ?? 0) > 0;
            this.scheduleBased = (this.currentTemplateType?.scheduleTypeID ?? 0) > 0;
            this.currentSchedule = this.filteredSchedules?.find((x) => x.scheduleResources[0].resourceId ==
              this.currentChecklist?.resourceID);
            if (this.currentChecklistTemplate) {
              this.currentChecklistTemplate.resource = this.currentChecklist.resource;
              if (
                !this.checklistTemplates.map((x) => x.id).includes(this.currentChecklistTemplate.id)) {
                this.checklistTemplates.push(this.currentChecklistTemplate);
              }
              this.templateCtrl.setValue(this.currentChecklistTemplate);
              this.templateCtrl.disable();
              this.currentResource = this.currentChecklist.resource;
            }
          }
        }
      }
    });
  }

  getTemplate(procedure: Procedure) {
    const checklistTemplate = this.checklistTemplates.filter(x => x.procedure).find(x => (x.procedureID == procedure.id ||
      x.procedureID == procedure.previousVersionID) && x.status == ChecklistTemplateStatusEnum.Active);
    return checklistTemplate;
  }

  hasTemplate(procedure: Procedure) {
    return this.getTemplate(procedure) != null;
  }

  selectedType(e: any) {
    this.currentTemplateType = e.option.value as TemplateType;
    this.currentProcedure = null;
    this.procedureCtrl.setValue(null);
    this.templateCtrl.setValue(null);
    this.currentSchedule = null;
    this.currentChecklistTemplate = null;
    this.typeCtrl.setValue(this.currentTemplateType);
    this.filterSchedules();
    this.selectedTemplateType();
  }

  /**
   * Selects active templates from the refreshed checklist-template store for the chosen type.
   * This avoids using the stale nested template collection retained after builder approval.
   */
  selectedTemplateType(): void {
    if (this.currentTemplateType) {
      // ChecklistTemplates is refreshed independently and contains the current approval statuses.
      const checklistTemplates = this.store.selectSnapshot((state) => state.ChecklistTemplates.data) as ChecklistTemplate[];
      this.checklistTemplates = checklistTemplates.filter(x =>
        x.templateTypeID == this.currentTemplateType?.id &&
        x.status == ChecklistTemplateStatusEnum.Active
      );
      this.currentTemplateType.checklistTemplates = this.checklistTemplates;
      this.checklistTemplatesFiltered = this.checklistTemplates.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.resourceString, b.resourceString));
      if (!this.checklistTemplates.length) {
        this.alert.message("GenChklistExec_NoTemplatesAvailable");
        this.clearSelection();
        return;
      }
      this.templateCtrl.enable();
      this.resourceBased = (this.currentTemplateType.resourceTypeID ?? 0) > 0;
      this.scheduleBased = (this.currentTemplateType.scheduleTypeID ?? 0) > 0;
      if (this.scheduleBased) {
        this.filterSchedules();
      } else if (this.resourceBased) {
        this.resources = this.checklistTemplates.map(x => x.resource).sort((a, b) => this.utils.SortBeamlines(a?.name, b?.name));
      } else if (this.currentTemplateType.allowMultipleVersions) {
      } else if (!this.scheduleBased && !this.resourceBased) {
        this.currentChecklistTemplate = this.currentTemplateType.checklistTemplates.find(x => x.status == ChecklistTemplateStatusEnum.Active);
        if (!this.currentChecklistTemplate) {
          this.alert.message("GenChklistExec_NoTemplatesAvailable");
          this.clearSelection();
        }
      }
    }
  }

  selectedTemplateName(e: any) {
    this.currentChecklistTemplate = e.option.value;
  }

  /**
   * Handles the selection of a procedure from the UI event.
   *
   * This method updates the current procedure, filters and sorts the checklist templates,
   * checks for the existence of a template for the selected procedure, and updates the
   * relevant form controls and state accordingly. If no template is available for the
   * selected procedure, it displays an alert and clears the selection.
   *
   * @param e - The event object containing the selected procedure option.
   */
  selectedProcedure(e: any) {
    this.currentProcedure = e.option.value as Procedure;
    this.checklistTemplates = this.checklistTemplates.filter(x => x.status == 1);
    this.checklistTemplatesFiltered = this.checklistTemplates.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.resourceString, b.resourceString));

    if (!this.hasTemplate(this.currentProcedure)) {
      this.alert.message("GenChklistExec_NoTemplatesAvailable");
      this.clearSelection();
      return;
    }

    this.procedureCtrl.setValue(this.currentProcedure);
    this.currentChecklistTemplate = this.getTemplate(this.currentProcedure);
    if (this.currentChecklistTemplate) {
      this.currentChecklistTemplate.templateType = this.templateTypes.find(x => x.id == this.currentChecklistTemplate?.templateTypeID
      );
      this.currentTemplateType = this.currentChecklistTemplate.templateType;
      this.templateCtrl.setValue(this.currentChecklistTemplate);
      this.typeCtrl.setValue(this.currentTemplateType);
      this.scheduleBased = true;
      this.filterSchedules();
      this.selectedTemplate(this.currentChecklistTemplate);
    }
  }

  changedProcedure() {
    this.filteredProcedures = this.procedures.filter(x => x?.procedureNumber.toLowerCase().includes(this.procedureCtrl.value.toLowerCase())) as Procedure[];
  }

  clearSelection() {
    this.typeCtrl.setValue(null);
    this.currentTemplateType = null;
    this.procedureCtrl.setValue(null);
    this.currentProcedure = null;
    this.templateCtrl.setValue(null);
    this.currentChecklistTemplate = null;
    this.templateCtrl.disable();
    this.loadChecklistTemplates();
    this.loadSchedules();
  }

  checkStatus() {
    const activeStatusOrder = this.currentTemplateType?.documentType?.checklistExecStatuses?.find(x => x.formStatusID == FormStatusEnum.Active)?.order;
    return (this.currentChecklist?.checklistStatus?.order ?? 0) <= (activeStatusOrder ?? 0);
  }

  // //#region Schedules

  loadSchedules() {
    this.schedules$ = this.store.select((state) => state.Schedules.data);
    this.schedulesSubs = this.schedules$.subscribe((data) => {
      if (data.length) {
        this.schedules = data.filter(x => x.statusId != ScheduleStatusEnum.remove && x.statusId != ScheduleStatusEnum.completed).sort((a, b) => this.utils.SortBeamlines(a.name, b.name));
        this.loadProcedures();
      }
    });
  }

  /**
   * Filters the list of schedules based on the currently selected template type and valid resource IDs.
   *
   * The method performs the following steps:
   * 1. Checks if a current template type and schedules are available; returns early if not.
   * 2. Extracts the relevant schedule type and subtype IDs from the current template type.
   * 3. Builds a list of valid resource IDs from the available checklist templates.
   * 4. Filters the schedules to include only those that:
   *    - Match the selected schedule type ID.
   *    - Match the selected schedule subtype ID (if specified).
   *    - Have a resource ID present in the list of valid resource IDs.
   * 5. For each filtered schedule, updates its `name` and `description` properties based on the associated resource.
   *
   * @remarks
   * This method updates the `filteredSchedules` property with the filtered and enriched schedules.
   */
  filterSchedules() {
    if (!this.currentTemplateType || !this.schedules?.length) return;

    const subtypeID = this.currentTemplateType.scheduleSubtypeID;
    const typeID = this.currentTemplateType.scheduleTypeID;
    const validResourceIDs = this.checklistTemplates?.map(t => t.resourceID) ?? [];

    this.filteredSchedules = this.schedules.filter(schedule => {
      const matchesType = schedule.typeId === typeID;
      const matchesSubtype = !subtypeID || schedule.scheduleSubtypeId === subtypeID;
      const resourceId = schedule.scheduleResources?.[0]?.resourceId;
      const isResourceValid = validResourceIDs.includes(resourceId);
      return matchesType && matchesSubtype && isResourceValid;
    });

    this.filteredSchedules.forEach(schedule => {
      const resource = schedule.scheduleResources?.[0]?.resource;
      schedule.name = resource?.name ?? '';
      schedule.description = resource?.description ?? '';
    });
  }


  filterTemplates(e: any) {
    const val = (e.target.value as string).toLowerCase();
    this.checklistTemplatesFiltered = this.checklistTemplates.filter(x => x.resourceString?.toLowerCase().includes(val));
  }

  getSchedule(id: number) {
    if (id) {
      this.currentSchedule = this.schedules?.find((x) => x.id == id);
    } else {
      this.currentSchedule = null;
    }
    return this.currentSchedule;
  }
  // //#endregion

  getInfo() {
    this.clear();
    this.loadDocumentTypes();
    const requestedTypeId = this.documentTypeId;
    this.builderService.getTemplateRolePermissionsByDocumentTypeID(this.documentTypeId).toPromise().then((data) => {
      if (requestedTypeId !== this.documentTypeId) return;
      if (data)
        this.documentRolePermissions = data.filter(x => x.templateTypeID == 0);
      this.loadTemplateTypes();
    });
  }

  /**
   * Clears selected checklist state and optionally keeps document role permissions for create/cancel flows.
   * @param preserveDocumentRolePermissions Keeps permissions already loaded for the current document type.
   */
  clear(preserveDocumentRolePermissions = false) {
    this.currentChecklist = null;
    this.currentSchedule = null;
    this.currentResource = null;
    this.currentTemplateType = null;
    this.procedureCtrl.setValue(null);
    this.currentProcedure = null;
    this.typeCtrl.setValue(this.currentTemplateType);
    this.scheduleBased = false;
    this.resourceBased = false;
    this.checklistTemplates = [];
    this.checklistTemplatesFiltered = this.checklistTemplates;
    this.templateCtrl.setValue(null);
    this.currentChecklistTemplate = null;
    this.sections = [];
    this.creating = false;
    if (!preserveDocumentRolePermissions)
      this.documentRolePermissions = undefined!;
  }

  displayProcedure(e: any) {
    return e ? e.procedureNumber : null;
  }

  displayTemplate(e: any) {
    return e ? (e.resource ? e.resource.name : e.resourceString) : null;
  }

  /**
   * Provides the beamline associated with the selected shutter for generic KE checklists.
   * Uses the relation name when the nested beamline resource was not included in the header payload.
   */
  get appliesToBeamlineName(): string | null {
    if (this.documentTypeId != this.genericKeyEnableTemplateDocumentTypeID || !this.currentResource)
      return null;

    if (this.currentResource.type == ResourceType.Beamline)
      return this.currentResource.name ?? null;

    // Shutters keep their related beamline as a child relation in the resource catalog.
    const relation = this.currentResource.childResources?.find(x => x.childResourceType == ResourceType.Beamline);
    return relation?.childResource?.name ?? relation?.childResourceName ?? null;
  }

  selectedTemplate(e: ChecklistTemplate) {
    this.currentChecklistTemplate = e;
    this.currentResource = this.currentChecklistTemplate.resource;
    this.currentSchedule = this.filteredSchedules.find(x => this.currentResource ? x.scheduleResources[0]?.resourceId == this.currentResource.id : x.scheduleResources[0].resourceString == this.currentChecklistTemplate?.resourceString);

    this.currentProcedure = this.procedures.find(x => x?.id == this.currentChecklistTemplate?.procedureID ||
      x?.previousVersionID == this.currentChecklistTemplate?.procedureID);
    this.procedureCtrl.setValue(this.currentProcedure);
  }

  /**
   * Starts create mode while preserving permissions for the current document type.
   */
  createNew() {
    this.clear(true);
    this.creating = true;
    if (this.scheduleBased) {
      this.loadSchedules();
    } else {
      this.loadTemplateTypes();
    }
    this.side.unselect();
    this.typeCtrl.enable();
    this.typeCtrl.setValue(null);
    this.procedureCtrl.enable();
    this.procedureCtrl.setValue(null);
  }

  /**
   * Creates a checklist after checking active schedule/resource duplicates.
   */
  async create() {
    if (this.creatingNew) return;           // guard double‑click
    this.creatingNew = true;
    const resourceID = this.currentChecklistTemplate?.resourceID ?? this.currentResource?.id ?? null;
    const closedStatuses = [FormStatusEnum.Canceled, FormStatusEnum.Closed];

    // Resource-based template types such as KE do not always have a schedule to compare.
    const existing = this.checklists.some(x =>
      closedStatuses.includes(x.checklistStatus?.formStatusID!) === false &&
      x.checklistTemplate?.templateTypeID === this.currentTemplateType?.id &&
      (
        (this.currentSchedule?.id != null && x.scheduleId === this.currentSchedule.id) ||
        (resourceID != null && x.resourceID === resourceID)
      ));
    if (existing && !this.currentTemplateType?.allowMultipleChecklists) {
      this.alert.message('ChecklistAlreadyOpen');
      this.creatingNew = false;
      return;
    }

    const checklist: Checklist = {
      id: 0,
      resourceID,
      scheduleId: this.currentSchedule?.id,
      checklistTemplateID: this.currentChecklistTemplate?.id,
      status: FormStatusEnum.Draft,
    };

    try {
      const data = await firstValueFrom(this.service.post(checklist));
      this.side.unselect();
      setTimeout(() => {
        this.currentChecklist = data;
        this.side.selectCreatedRow(this.currentChecklist);
        this.setOpenDocument(this.documentTypeId, this.currentChecklist?.id);
      }, 500);
    } catch (err) {
      console.error(err);
    } finally {
      this.creatingNew = false;
      this.creating = false;
    }
  }

  async loadInfo() {
    this.loadSchedules();
    this.loadTemplateTypes();
    this.currentProcedure = null;
    if (this.currentChecklist) {
      this.rssFunctionalTestService.readByChecklistID(this.currentChecklist.id).subscribe(
        (data) => (this.rssFunctionalTest = data), () => (this.rssFunctionalTest = null));

      if (!this.currentChecklist?.wfTable) {
        this.currentChecklist = this.checklists.find(c => c.id == this.currentChecklist?.id);
        if (!this.currentChecklist?.wfTable && this.currentChecklist?.id)
          this.currentChecklist = await this.service.getById(this.currentChecklist.id).toPromise();
      }

      if (this.currentChecklist) {
        if (this.currentChecklist.scheduleId)
          this.currentChecklist.schedule = this.getSchedule(this.currentChecklist.scheduleId);
        this.sections = [];
        this.creating = false;
        this.currentProcedure = this.filteredProcedures?.find(x => x.id == this.currentChecklist?.schedule?.procedureID ||
          (x.procedureMasterID == this.currentChecklist?.schedule?.procedureMasterID && x.status == 1));
        this.isProcedureRelated = this.proceduresVisible();
        this.procedureCtrl.setValue(this.currentProcedure);
        this.procedureCtrl.disable();
      }
    }
    else {
      this.currentTemplateType = null;
      this.currentChecklistTemplate = null;

      this.typeCtrl.setValue(null);
      this.typeCtrl.enable();

      this.currentProcedure = null;
      this.procedureCtrl.setValue(null);
      this.currentResource = null;
      this.resourceBased = false;
      this.currentChecklistTemplate = null;
      this.templateCtrl.setValue(null);

      this.sections = [];
    }
    this.service.isPreparer = this.checkPriv(
      this.checklistPrivilege.CreateChecklist
    );
    if (this.currentChecklist?.documentTypeID)
      this.setOpenDocument(this.currentChecklist.documentTypeID, this.currentChecklist?.id);
    this.getSections();
    this.getReview();
  }

  getSections() {
    this.currentChecklistTemplate = this.currentChecklist?.checklistTemplate;

    this.typeCtrl.setValue(this.currentChecklistTemplate?.templateType);
    this.typeCtrl.disable();
    this.procedureCtrl.disable();

    this.resourceBased = (this.currentChecklistTemplate?.templateType?.resourceTypeID ?? 0) > 0;
    this.scheduleBased = (this.currentChecklistTemplate?.templateType?.scheduleTypeID ?? 0) > 0;

    this.currentResource = this.currentChecklist?.resource;
    this.currentSchedule = this.filteredSchedules?.find(x => x.id == this.currentChecklist?.scheduleId);

    if (this.currentSchedule) {
      this.currentResource = this.currentSchedule.scheduleResources.find(x => (x.resourceId ?? 0) > 0)?.resource;
      if (this.currentChecklist)
        this.currentChecklist.schedule = this.currentSchedule;
    }

    this.sections = (this.currentChecklist?.wfTable ? this.currentChecklist.wfTable.wfTableLocal?.wfSectionLocals : []) as WFSectionLocalResource[];


    this.isCollapsible = this.collapsible();

    if (!this.service.expansionStatus.map(s => s.checklistID).includes(this.currentChecklist?.id ?? 0)) {
      if (this.isCollapsible) { this.collapseAll(this.collapsedAll); }
    }

    this.getParticipants(this.sections);
    this.loadAnnotations();
    this.setHeights();
  }

  getReview() {
    const review = this.reviews?.find(r => r.checklistID == this.currentChecklist?.id);
    if (review && this.currentChecklist) this.currentChecklist.review = review;
  }

  checkDisabled(s: WfSignature): boolean {
    const statusId = this.utils.JSONparse(s.configuration)?.status;
    const statuses = this.currentChecklistTemplate?.documentType?.checklistExecStatuses;
    const status = statuses?.find(x => x.id == statusId);

    return this.activeAnnotations > 0 && status == statuses?.find(x => x.formStatusID == FormStatusEnum.PendingReview && this.currentChecklist?.checklistStatus?.formStatusID == FormStatusEnum.Correcting);
  }

  loadAnnotations() {
    this.annotations$ = this.store.select(state => state.Annotations.data);
    this.annotationsSubs = this.annotations$.subscribe(data => {
      if (this.currentChecklist) {
        this.annotations = data.filter(x => x.checklistID == this.currentChecklist?.id);
        this.activeAnnotations = this.annotations?.filter(x => x.status == AnnotationStatus.Active).length;
        this.totalAnnotations = this.annotations?.filter(x => x.checklistID == this.currentChecklist?.id).length;
      }
    });
  }

  getParticipants(sections: WFSectionLocalResource[]) {
    const participantSections = sections?.filter(z => z.wfStepLocals?.some(s => s.wfTaskLocals.some((t) => t.code == "PARTICIPANT")));
    if (participantSections?.length) {
      this.participants = [];
    }
    participantSections?.map(z => {
      z.wfStepLocals?.map(s => {
        s.wfTaskLocals.map(t => {
          const taskSigned = t.wfTasks?.[0].signedBy;
          if (t.code == "PARTICIPANT" && taskSigned) {
            this.participants.push(taskSigned as User);
          }
        });
      });
    });
    this.service.participants = this.participants;
  }

  applyFilter(e: any) {
    this.side.applyFilter(e);
  }

  /**
   * Cancels create mode and restores permissions when a stale create flow cleared them.
   */
  noCreate() {
    this.creating = false;
    this.scheduleBased = false;
    this.resourceBased = false;
    this.isProcedureRelated = false;
    this.currentProcedure = null;
    this.currentChecklistTemplate = null;
    this.side.unselect();
    if (!this.documentRolePermissions)
      this.getInfo();
  }

  checkPriv(privilege: ChecklistPriv) {
    if (privilege == ChecklistPriv.Review) {
      return this.service.isReviewer;
    }
    return this.hasRoles(this.documentRolePermissions?.filter(x => x.checklistPrivilege == privilege).map((x) => x.roleID));
  }

  collapseAll(val?: boolean) {

    this.collapsedAll = val ?? !this.collapsedAll;

    if (this.currentChecklist) {
      this.sections?.map((section) => {
        section.collapsed = this.collapsedAll;
        this.service.saveSectionExpanded(this.currentChecklist!.id, section.id, this.collapsedAll);

        section.wfStepLocals?.map((step) => {
          step.collapsed = this.collapsedAll;
          this.service.saveStepExpanded(this.currentChecklist!.id, step.id, this.collapsedAll);
        });
        return section;
      });
      this.service.saveExpansionStatus(this.currentChecklist, this.collapsedAll);
    }

    if (!this.collapsedAll)
      this.alert.warning('Expanding all sections may cause slow performance issues on large checklists.');
  }

  cancel() {
    const canceledStatus = this.currentChecklist?.checklistTemplate?.documentType?.checklistExecStatuses?.find(
      (x) => x.formStatusID == FormStatusEnum.Canceled
    );
    if (canceledStatus) {
      const cancel = this.dialog.open(CancelDialogComponent, {
        width: "600px",
        data: {},
      });
      cancel.afterClosed().subscribe((data) => {
        if (data.accept) {
          const checklistStatusResource: SaveChecklistStatusResource = {
            id: this.currentChecklist?.id ?? 0,
            checklistStatusID: canceledStatus.id,
            status: canceledStatus.id,
            reason: data.text,
          };

          this.service.cancel(checklistStatusResource).toPromise().then((res) => {
            this.alert.message("CancelSuccess", [{ placeholder: "{reason}", value: data.text },]);
            this.creating = false;

            if (res) {
              this.currentChecklist = res;
              this.side.selectCanceledRow(this.currentChecklist);
            } else {
              this.sections = [];
              this.currentChecklist = null;
              this.side.unselect();
              // this.checklistSections.loadSections();
            }
          })
            .catch((error) => {
              this.alert.defaultError();
              console.log(error);
              this.creating = false;
            });
        }
      });
    }
  }

  openVerificationList() {
    if (this.currentChecklist?.id) {
      this.service.getVerifiedById(this.currentChecklist.id).toPromise().then((response) => {
        if (response) {
          this.currentChecklist = response;
          this.store.dispatch(
            new ChecklistsUpdate(this.currentChecklist.id, this.currentChecklist)
          );
        }
      });
    }
  }


  precheckChanged(e: any) {
    this.precheck = e;
  }

  proceduresVisible(): boolean {
    const result = this.procedures?.length > 0 && (this.currentSchedule?.type?.procedureTypeID || !this.currentTemplateType) && (this.creating || (this.currentChecklist != null && this.currentProcedure != null));
    return result as boolean;
  }

  collapsible() {
    if (this.currentChecklist) {
      const sections = this.currentChecklist.wfTable?.wfTableLocal?.wfSectionLocals;
      if (sections) {
        const steps = sections.map(s => s.wfStepLocals as WFStepLocalResource[]).reduce((acc, arr) => [...acc, ...arr], []);

        return (
          sections?.filter((x) => x.collapsible)?.length > 0 ||
          steps?.filter((x) => x.collapsible)?.length > 0
        );
      }
    }
    return false;
  }

  openReview() {
    if (this.currentChecklist?.review?.reviewCycle) {
      const document = this.redirect.findDocument(this.currentChecklist.review.reviewCycleID, FormType.REVIEW);
      localStorage.setItem('redirectID', this.currentChecklist.review.id.toString());
      if (document)
        this.redirect.openDocument(document);
    }
  }
}
